/* eslint-disable react-hooks/rules-of-hooks */
import {
  Box,
  Grid,
  Typography,
  InputLabel,
  FormHelperText,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { CustomButton, CustomInput, Wrapper } from "../../components";
import { validationErrors } from "../../constants/validationErrors";
import { useTheme } from "@emotion/react";
import Select from "react-select";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAppState } from "./state";
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../utils";
import { userUpdate } from "../../slice/user.slice";
import Phone from "../../components/Phone";
import { FormattedMessage, useIntl } from "react-intl";
import { LanguageContext } from "../../context/languageContext";
import {
  countryOptions,
  countryOptionsAr,
  countryOptionsFr,
} from "../../utils";

const customStyles = {
  menu: (provided, state) => ({
    ...provided,
    zIndex: "4",
  }),
  control: (provided, state) => ({
    ...provided,
    minHeight: "52px",
    backgroundColor: "hsl(0deg 0% 97.65%)",
    borderRadius: "10px",
  }),
};

const ContactInformation = ({ onNext, onPrev }) => {
  const { locale, selectLanguage } = useContext(LanguageContext);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(false);
  const { palette } = useTheme();
  const userFormData = useSelector((state) => state.user.userFormData);
  const [state, setState] = useAppState();
  const [countryLists, setCountryList] = useState(countryOptions);
  let updateMessage = useIntl().formatMessage({ id: "yourRequestTaken" });

  const validationSchema = Yup.object().shape({
    VendorAddress: Yup.string().required(
      useIntl().formatMessage({ id: "vendorAddressLine1isRequired" })
    ).max(255, useIntl().formatMessage({ id: "max255CharAllowed" })),
    VendorAddress2: Yup.string().required(
      useIntl().formatMessage({ id: "vendorAddressLine2isRequired" })
    ).max(255, useIntl().formatMessage({ id: "max255CharAllowed" })),
    VendorCity: Yup.string().required(
      useIntl().formatMessage({ id: "vendorCityisRequired" })
    ).max(255, useIntl().formatMessage({ id: "max255CharAllowed" })),
    VendorRegion: Yup.string().required(
      useIntl().formatMessage({ id: "vendorState/Province/RegionisRequired" })
    ).max(255, useIntl().formatMessage({ id: "max255CharAllowed" })),
    VendorPostalCode: Yup.string().required(
      useIntl().formatMessage({ id: "vendorPostalCodeisRequired" })
    ).max(255, useIntl().formatMessage({ id: "max255CharAllowed" })),
    VendorCountry: Yup.object().required(
      useIntl().formatMessage({ id: "vendorCountryisRequired" })
    ),
    VendorPhone: Yup.string().required(
      useIntl().formatMessage({ id: "vendorPhoneisRequired" })
    ),
  });

  const {
    handleSubmit,
    formState: { errors },
    control,
    reset,
  } = useForm({
    defaultValues: state,
    resolver: yupResolver(validationSchema),
    mode: "all",
  });

  useEffect(() => {
    if (userFormData?.VendorAddress && !state?.VendorAddress) {
      reset({
        VendorAddress: userFormData?.VendorAddress,
        VendorAddress2: userFormData?.VendorAddress2,
        VendorCity: userFormData?.VendorCity,
        VendorRegion: userFormData?.VendorRegion,
        VendorPostalCode: userFormData?.VendorPostalCode,
        VendorCountry: countryLists.filter(
          (item) => item.value === userFormData?.VendorCountry
        )[0],
        VendorPhone: userFormData?.VendorPhone,
        VendorEmail: userFormData?.VendorEmail,
      });
    }
    if (locale == "ar") {
      setCountryList(countryOptionsAr);
    } else if (locale == "fr") {
      setCountryList(countryOptionsFr);
    } else {
      setCountryList(countryOptions);
    }
  }, [userFormData]);

  const onSubmit = (data, name) => {
    setLoading(true);
    var finalData = data;
    finalData.VendorPhone = finalData.VendorPhone.split("/")[0];
    setState({ ...state, ...finalData });
    onNext();
  };
  const onError = (errors, e) => {
    console.log(errors, e);
  };

  const handleSwitchLang = (lang) => {
    selectLanguage(lang);
    if (lang == "ar") {
      setCountryList(countryOptionsAr);
    } else if (lang == "fr") {
      setCountryList(countryOptionsFr);
    } else {
      setCountryList(countryOptions);
    }
  };

  return (
    <>
      {toast?.type && showToast(toast?.type, toast?.message, setToast)}
      <Box>
        {userFormData?.Status === "In Progress" && (
          <Wrapper>
            {" "}
            <FormHelperText
              sx={{
                fontSize: "20px",
                paddingBottom: "10px",
              }}
            >
              <strong>
                <FormattedMessage id="waitingAprroval" />
              </strong>
            </FormHelperText>
          </Wrapper>
        )}
        <form onSubmit={handleSubmit(onSubmit, onError)}>
          <Wrapper>
            <Box
              sx={
                userFormData?.Status === "In Progress"
                  ? {
                      opacity: [0.9, 0.8, 0.7],
                      pointerEvents: "none",
                    }
                  : {}
              }
            >
              <Grid
                container
                sx={{
                  "& .MuiGrid-container": {
                    marginBottom: "0 !important",
                    "& .MuiGrid-root": {
                      marginBottom: "20px",
                    },
                  },
                  "& .MuiGrid-root": {
                    marginBottom: "20px",
                  },
                }}
              >
                <Grid item lg={12} sm={12} xs={12}>
                  <CustomInput
                    label={useIntl().formatMessage({ id: "addressLine1" })}
                    type="text"
                    placeholder={useIntl().formatMessage({
                      id: "enterAddressLine1",
                    })}
                    name="VendorAddress"
                    error={errors?.VendorAddress?.message}
                    control={control}
                  />
                </Grid>
                <Grid item lg={12} sm={12} xs={12}>
                  <CustomInput
                    label={useIntl().formatMessage({ id: "addressLine2" })}
                    type="text"
                    placeholder={useIntl().formatMessage({
                      id: "enterAddressLine2",
                    })}
                    name="VendorAddress2"
                    error={errors?.VendorAddress2?.message}
                    control={control}
                  />
                </Grid>
                <Grid container columnSpacing={3} sx={{ marginBottom: "20px" }}>
                  <Grid item sm={6} xs={12}>
                    <CustomInput
                      label={useIntl().formatMessage({ id: "city" })}
                      type="text"
                      placeholder={useIntl().formatMessage({ id: "enterCity" })}
                      name="VendorCity"
                      error={errors?.VendorCity?.message}
                      control={control}
                    />
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <CustomInput
                      label={useIntl().formatMessage({
                        id: "vendorState/Province/Region",
                      })}
                      type="text"
                      placeholder={useIntl().formatMessage({
                        id: "enterVendorState/Province/Region",
                      })}
                      name="VendorRegion"
                      error={errors?.VendorRegion?.message}
                      control={control}
                    />
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <CustomInput
                      label={useIntl().formatMessage({ id: "postalCode" })}
                      type="text"
                      placeholder={useIntl().formatMessage({
                        id: "enterPostalCode",
                      })}
                      name="VendorPostalCode"
                      rules={{
                        required: validationErrors.required,
                      }}
                      error={errors?.VendorPostalCode?.message}
                      control={control}
                    />
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <Box component="div" className="form-group">
                      <InputLabel shrink htmlFor="bootstrap-input">
                        <FormattedMessage id="country" />
                      </InputLabel>
                      <Controller
                        name="VendorCountry"
                        control={control}
                        render={({ field }) => (
                          <Select
                            {...field}
                            styles={customStyles}
                            options={countryLists}
                          />
                        )}
                      />
                      {errors?.VendorCountry?.message && (
                        <FormHelperText error>
                          {errors?.VendorCountry?.message}
                        </FormHelperText>
                      )}
                    </Box>
                  </Grid>
                </Grid>

                <Grid item lg={12} sm={12} xs={12}>
                  <Phone
                    name="VendorPhone"
                    control={control}
                    label={useIntl().formatMessage({ id: "vendorPhone" })}
                    required={true}
                    errors={errors}
                  />
                </Grid>
                {/* <Grid item lg={12} sm={12} xs={12}>
                <CustomInput
                  disabled={true}
                  label={useIntl().formatMessage({ id: "vendorEmail" })}
                  type="text"
                  placeholder={vendorEmail}
                  name="VendorEmail"
                  control={control}
                />
              </Grid> */}
                {/* <Grid item lg={12} sm={12} xs={12}>
              <CustomInput
                label="Website"
                type="text"
                placeholder={useIntl().formatMessage({ id: "enterWebsite" })}
                name="website"
                rules={{
                  required: validationErrors.required,
                }}
                error={errors?.website?.message}
                control={control}
              />
            </Grid> */}
              </Grid>
            </Box>
          </Wrapper>
          <Box component="div">
            <Box className="dashboard-footer">
              <Box className="footer-item">
                <Typography
                  color={
                    locale === "en"
                      ? palette.secondary[700]
                      : palette.secondary[400]
                  }
                  onClick={() => handleSwitchLang("en")}
                >
                  <FormattedMessage id="english" />
                </Typography>
                <Typography
                  color={
                    locale === "fr"
                      ? palette.secondary[700]
                      : palette.secondary[400]
                  }
                  onClick={() => handleSwitchLang("fr")}
                >
                  <FormattedMessage id="french" />
                </Typography>
                <Typography
                  color={
                    locale === "ar"
                      ? palette.secondary[700]
                      : palette.secondary[400]
                  }
                  onClick={() => handleSwitchLang("ar")}
                >
                  <FormattedMessage id="arabic" />
                </Typography>
              </Box>
              <Box display="flex" columnGap="10px">
                <CustomButton
                  title={useIntl().formatMessage({ id: "back" })}
                  outline
                  size="small"
                  onClick={onPrev}
                />
                <CustomButton
                  title={useIntl().formatMessage({ id: "next" })}
                  size="small"
                  type="submit"
                  onClick={handleSubmit((data) => onSubmit(data, "next"))}
                />
                {/* {userFormData && userFormData?.Status !== "In Progress" && (
                  <CustomButton
                    title={useIntl().formatMessage({ id: "update" })}
                    type="submit"
                    size="small"
                    variant="contained"
                    loading={loading}
                    onClick={handleSubmit((data) => onSubmit(data, "update"))}
                  />
                )} */}
              </Box>
            </Box>
          </Box>
        </form>
      </Box>
    </>
  );
};

export default ContactInformation;
